export enum POST_CATEGORIES {
    DEFAULT = '',
    ALL_POSTS = 'All',
    LIFESTYLE = 'Lifestyle',
    NUTRITION = 'Nutrition',
    MOST_RECENT = 'Most Recent',
    BREAKFAST_AND_BRUNCH = 'Breakfast and Brunch',
    FOOD_GUIDE = 'Food Guides',
    JUICES_AND_SMOOTHIES = 'Juices and Smoothies',
    LUNCH_AND_DINNER = 'Lunch and Dinner',
    SNACKS = 'Snacks',
    TREATS = 'Treats',
    BABY = 'Baby',
    BEAUTY = 'Beauty',
    FITNESS_AND_WELLNESS = 'Fitness and Wellness',
    INTERVIEWS = 'Interviews',
    MINDFUL_WITH_ME = 'Mindful With Me',
    SHOPPING = 'Shopping',
    SKINCARE = 'Skincare',
}

export enum IG_FEEDS {
    IMAGE = 'IMAGE',
    CAROUSEL_ALBUM = 'CAROUSEL_ALBUM',
    VIDEO = 'VIDEO',
}

export enum AXIOS_METHODS {
    GET = 'GET',
    POST = 'POST',
    PATCH = 'PATCH',
    PUT = 'PUT',
    DELETE = 'DELETE',
}

export enum ROUTES {
    TERMS = '/terms-of-use',
    MEMBERSHIP_TERMS = '/membership-terms',
    PRIVACY_POLICY = '/privacy-policy',
    COOKIE_POLICY = '/cookie-policy',
    CREATORS = '/creators',
    TESTIMONIALS = '/testimonials',
    ABOUT = '/about',
    LIFESTYLE = '/lifestyle',
    NUTRITION = '/nutrition',
    HELP = '/help',
    WORKOUTS = '/classes',
    PROGRAM = '/program',
    PROFILE = '/profile/personal-info',
    PASSWORD = '/profile/password',
    BILLING = '/profile/billing',
    EMAILS = '/profile/emails',
    CLASS_HISTORY = '/profile/class-history',
    ACHIEVEMENTS = '/profile/achievements',
    RESUME = '/resume',
    FAVORITE = '/favorite',
    FAQ = '/faq',
    LOGIN = '/login',
    RESET_PASSWORD = '/reset-password',
    SET_PASSWORD = '/resetpwd',
    CONTACT_US = '/contact-us',
    REGISTRATIONS = '/registration',
    VIDEO_DETAILS = '/video-details', // For ContentStack purpose only
    SHOP = '/shop',
    MELISSA_LOOKS = "/shop/melissa's-looks",
    MWH_PRODUCTS = '/shop/mwh-props',
    DISCOUNT_CODES = '/shop/discount-codes',
    FASHION = '/shop/fashion',
    BEAUTY = '/shop/beauty',
    LIFE = '/shop/life',
    GIFT_CARDS = '/gift-cards',
    GIFT_GUIDE = '/shop/gift-guide',
    SEARCH_VIDEO = '/search/video',
    SEARCH_POST = '/search/post',
    ALL_VIDEOS = '/videos',
    SUCCESS_PURCHASE = '/success-purchase',
    REDEEM_GIFT = '/redeem',
    PIN_LOGIN = '/pin-login',
    EVENT = '/event',
    MARKETING = '/marketing',
    COMMENTS_SSO = '/comments-sso/:userId/:fullName/:email/:imageUrl/:identifier/:title',
    COMMENTS = '/comments/:identifier/:title',
    TESTIMONIALS_RELEASE = '/testimonial-release',
    SUBSCRIBE = '/subscribe',
    NEWSLETTER = '/newsletter',
    RECOMMENDATION = '/recommended',
}

export enum PARENT_ROUTES {
    POSTS,
    VIDEO_FILTER,
}

/**
 * Content stack
 */
export enum CONTENT_BODY {
    LISTINGS = 'BodyBodyListings',
    CALL_OUT = 'BodyBodyCallout',
    CAROUSEL = 'BodyBodyCarousel',
    IMAGE_TEXT = 'BodyBodyImageText',
    TEXT = 'BodyBodyText',
    PRESS_HIGHLIGHTS = 'BodyBodyPressHighlights',
    SPONSORS = 'BodyBodySponsors',
    VIDEO_LINKS = 'BodyBodyCarouselVideoLinks',
    CODE_BLOCK = 'BodyBodyCodeBlock',
    GRID_BLOCK = 'BodyBodyGridBlock',
}

export enum VIDEO_CAROUSEL {
    VIDEO = 'BodyBodyCarouselVideoLinksBlockCarouselVideos',
    SLIDE = 'BodyBodyCarouselVideoLinksBlockCarouselSlide',
}

export enum POST_CONTENT_BODY {
    IMAGE = 'PostContentImage',
    TEXT = 'PostContentText',
    CODE = 'PostContentCodeBlock',
    LISTINGS = 'PostContentListings',
    VIDEO = 'PostContentVideo',
}

export enum LISTINGS_TYPE {
    CREATOR = 'Creator',
    TESTIMONIALS = 'Testimonials',
    RECIPES = 'Recipes',
    POSTS = 'Posts',
    VIDEO_CATEGORIES = 'Video Categories',
    PROGRAM = 'Program',
    SHOP_CATEGORIES = 'Shop Categories',
}

export enum CODE_BLOCK_TYPE {
    INSTAGRAM = 'Instagram',
    YOUTUBE = 'Youtube',
}

//storage token
export enum AUTH_TOKEN {
    ENDEAVOR_AUTH_TOKEN = 'endeavor-auth-token',
    MWH_AUTH_TOKEN = 'mwh-auth-token',
}

//Guest user
export enum GUEST_USER {
    IS_UN_AUTHENTICATED_USER = 'YES',
    IS_GUEST_USER = 'GUEST USER',
}

//Authenticated user
export enum AUTHENTICATED_USER {
    IS_AUTHENTICATED_USER = 'YES',
    IS_LOGIN_USER = 'Logged IN USER',
}

// Encrypted login user data
export enum ENCRYPTED_LOGIN_USER {
    KEY = 'login-encrypted-creds',
}

//onboarding
export enum ONBOARDING_QUESTION {
    MULTI_SELECT = 'MULTI_SELECT',
    SINGLE_SELECT = 'SINGLE_SELECT',
}

//Auth
export enum USER_AUTH {
    AUTH_PROVIDER = 'ID',
}

//Licence Period
export enum LICENCE_PERIOD {
    P0D = 'P0D',
}

//Plan managing
export enum PLAN_MANAGEMENT {
    PAUSED = 'PAUSED',
    NOT_ALLOWED = 'NOT_ALLOWED',
    AUTO_RENEWING = 'AUTO_RENEWING',
    NON_RENEWING = 'NON_RENEWING',
}

//Licence status
export enum LICENCE_STATUS {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    TRIAL_ACTIVE = 'TRIAL_ACTIVE',
}

export enum PROMO_CODE_STATE {
    ACTIVE = 'ACTIVE',
    UPCOMING = 'UPCOMING',
}

//Licence status
export enum VIDEO_ACCESS_LEVEL {
    GRANTED = 'GRANTED',
    DENIED = 'DENIED',
}

//User licence
export enum LICENCE_PLAN {
    SELECTED_LICENCE = 'SELECTED_LICENCE',
    SUBSCRIBED_USER = 'SUBSCRIBED_USER',
    IS_UNDER_PROCESS = 'IS_UNDER_PROCESS',
}

//Card type
export enum CARD_TYPE {
    VISA = 'visa',
    DISCOVER = 'discover',
    UNION_PAY = 'unionpay',
    AMERICAN_EXPRESS = 'amex',
    MASTERCARD = 'mastercard',
    JCB = 'jcb',
}

export enum VOD_TYPE {
    LIVE = 'LIVE',
}

export enum USER_TYPE {
    VIP = 'VIP',
    REGULAR = 'REGULAR',
}

export enum GIFT_USER_SUBSCRIPTION {
    GIFT_SUBSCRIPTION_RECIPIENT_DETAILS = 'GIFT-SUBSCRIPTION-RECIPIENT-DETAILS',
}

export enum PURCHASE_USER_SUBSCRIPTION {
    STRIPE = 'STRIPE',
    APPLE_IAP = 'APPLE_IAP',
    GOOGLE_IAP = 'GOOGLE_IAP',
    IMPORT_PLACEHOLDER = 'IMPORT_PLACEHOLDER',
}

export enum STRIPE_ERROR_CODES {
    EXPIRED_CARD = 'expired_card',
}

export enum DISCOUNT_CODE {
    DISCOUNT_ALREADY_APPLIED = 'DISCOUNT_ALREADY_APPLIED',
}

export enum EDV_IMAGE_API {
    COVER = '1000x568',
    THUMB = '500x375',
}

export enum MOBILE_OS {
    IOS = 'ios',
    ANDROID = 'android',
}

export enum PROFILE_IMAGE_UPLOAD_ACTIONS {
    SIZE_ERROR = 'SIZE-ERROR',
    TYPE_ERROR = 'TYPE-ERROR',
    IMAGE_SOURCE = 'IMAGE-SOURCE',
    OPEN_IMAGE_EDITOR_MODAL = 'OPEN_IMAGE_EDITOR_MODAL',
    UPLOAD_PROFILE_LOADING = 'UPLOAD_PROFILE_LOADING',
    UPLOAD_PROFILE_SNACKBAR_VISIBLE = 'UPLOAD_PROFILE_SNACKBAR_VISIBLE',
}

export enum SPLIT_LINK {
    DOMAIN = 'spl.it',
}

export enum SMART_BANNER {
    COOKIES = 'smartbanner-closed',
}

export const SUBSCRIPTION_KEY = process.env.REACT_APP_PUB_NUB_SUBSCRIPTION_KEY
    ? process.env.REACT_APP_PUB_NUB_SUBSCRIPTION_KEY
    : ''
export const PUBNUB_LIVE_EVENT = process.env.REACT_APP_PUB_NUB_LIVE_EVENT
    ? process.env.REACT_APP_PUB_NUB_LIVE_EVENT
    : ''
export const PUBNUB_LIVE_EVENT_END = process.env
    .REACT_APP_PUB_NUB_LIVE_EVENT_END
    ? process.env.REACT_APP_PUB_NUB_LIVE_EVENT_END
    : ''

export enum PROFILE_ACHIEVEMENT_CATEGORIES {
    CLASS = 'classroom',
    MEMBERSHIP = 'membership',
    PROGRAM = 'program',
}
